import { EntityId } from "@reduxjs/toolkit";
import React from "react";
import { useGetAllInventoriesForShopQuery } from "../api/inventoryApi";
import InventoryListPresentation from "../presentation/InventoryListPresentation";
type InventoryListContainerProps = {
  shopId: EntityId;
};
const InventoryListContainer: React.FC<InventoryListContainerProps> = ({
  shopId
}) => {
  const {
    data: inventoriesList,
    
    isSuccess,
  } = useGetAllInventoriesForShopQuery(shopId);
  return (
    <>
      {isSuccess && (
        <InventoryListPresentation inventoriesList={inventoriesList} />
      )}
    </>
  )
}

export default InventoryListContainer
